var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddhar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,24c-6.3,0-12.6,0-18.8,0c-0.1,0-0.1,0-0.2-0.1C1,23.5,0,22.3,0,20.9C0,14.9,0,9,0,3c0-1.6,1.4-3,3-3 c6,0,12,0,18,0c0.5,0,1,0.1,1.4,0.4c0.8,0.5,1.3,1.2,1.5,2.2c0,6.3,0,12.6,0,18.8c-0.1,0.4-0.2,0.7-0.4,1 C23.1,23.3,22.4,23.8,21.4,24z M22.5,13c0-0.1,0-0.2,0-0.3c0-3.2,0-6.3,0-9.5c0-0.2,0-0.3,0-0.5C22.3,2,21.8,1.5,21,1.5 c-6,0-12.1,0-18.1,0c-0.1,0-0.2,0-0.3,0C1.9,1.7,1.5,2.3,1.5,3.2c0,4.3,0,8.6,0,12.9c0,0.1,0,0.2,0,0.2c0.1,0,0.1-0.1,0.2-0.1 c1.1-0.9,2.2-1.9,3.3-2.8c0.9-0.7,1.8-0.7,2.7,0c0.7,0.6,1.3,1.1,2,1.7c0.3,0.2,0.3,0.2,0.5,0c2-2,4-4,6-6c0.2-0.2,0.3-0.3,0.6-0.5 c0.9-0.5,1.8-0.3,2.5,0.5s1.3,1.6,2,2.4C21.7,12,22.1,12.5,22.5,13z M12,22.5c2.9,0,5.9,0,8.8,0c1.1,0,1.8-0.8,1.8-1.7 c0-1.8,0-3.5,0-5.3c0-0.2,0-0.3-0.1-0.4c-1.1-1.3-2.1-2.6-3.2-3.9c-0.4-0.4-0.7-0.9-1.1-1.3c-0.2-0.3-0.5-0.3-0.7,0 c-0.1,0.1-0.1,0.1-0.2,0.2c-2.2,2.2-4.4,4.4-6.5,6.5c-0.5,0.5-0.8,0.5-1.3,0.1c-0.9-0.7-1.8-1.5-2.6-2.2c-0.3-0.2-0.5-0.2-0.7,0 c-1.5,1.2-2.9,2.5-4.4,3.7c-0.1,0.1-0.2,0.2-0.1,0.3c0,0.8,0,1.7,0,2.5c0,0.3,0.1,0.6,0.3,0.9c0.4,0.5,0.9,0.6,1.5,0.6 C6.2,22.5,9.1,22.5,12,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,3C9.5,3,11,4.5,11,6.4S9.5,9.8,7.6,9.8S4.1,8.2,4.2,6.4C4.1,4.5,5.7,3,7.6,3z M7.6,4.4c-1.1,0-2,0.9-2,2 s0.9,1.9,2,1.9s2-0.9,1.9-2C9.5,5.3,8.7,4.4,7.6,4.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddhar);
export default __webpack_public_path__ + "static/media/addhar.5979e5066d18b3571a437247637e1ac6.svg";
export { ForwardRef as ReactComponent };